<template>
  <div class="dialog-wrap">
    <el-dialog
      title="内容版块编辑"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
      width="480px"
    >
      <el-form
        class="form"
        :model="dataForm"
        :rules="rules"
        ref="dataForm"
        label-width="100px"
      >
        <el-form-item
          label="版块标题"
          prop="title"
        >
          <el-input
            v-model="dataForm.title"
            placeholder="请输入版块标题"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="副标题"
          prop="subtitle"
        >
          <el-input
            v-model="dataForm.subtitle"
            placeholder="请输入版块副标题"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="版块位置"
          prop="site"
        >
          <el-select
            v-model="dataForm.site"
            placeholder="请选择版块位置"
            style="width: 100%;"
          >
            <el-option
              v-for="item in sites"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="布局方向"
          prop="layout"
        >
          <el-select
            v-model="dataForm.layout"
            placeholder="请选择布局方向"
            style="width: 100%;"
          >
            <el-option
              v-for="item in layouts"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="内容类型"
          prop="type"
        >
          <el-select
            v-model="dataForm.type"
            placeholder="请选择内容类型"
            style="width: 100%;"
            @change="handleTypChange"
          >
            <el-option
              v-for="item in types"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="关联内容组"
          prop="group_id"
        >
          <el-select
            v-model="dataForm.group_id"
            clearable
            :placeholder="dataForm.type ? '请选择内容组' : '请先选择内容内容类型'"
            :disabled="!dataForm.type"
            style="width: 100%;"
          >
            <el-option
              v-for="item in groups"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="自定义条件"
          prop="params"
        >
          <el-input
            v-model="dataForm.params"
            type="textarea"
            placeholder="请输扩JSON格式的过滤条件"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="最大展示数量"
          prop="max_num"
        >
          <el-input
            v-model="dataForm.max_num"
            placeholder="请输入最大展示数量"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="跳转链接" prop="link_url">
          <el-input v-model="dataForm.link_url" placeholder="请输入跳转链接"></el-input>
        </el-form-item> -->
        <el-form-item
          label="排序值"
          prop="sort"
        >
          <el-input
            v-model="dataForm.sort"
            placeholder="请输入排序值，纯数字"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="在线状态"
          prop="status"
        >
          <el-switch v-model="dataForm.status"></el-switch>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="handleClose">取 消</el-button>
        <el-button
          type="primary"
          @click="handleSubmit"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { collegeSectionUpdate } from '@/api/section'
import { productCategoryList } from '@/api/product'
import { articleCategoryList } from '@/api/article'
import { readcategorylist } from "@/api/read";
import { materialcategorylist } from "@/api/material";


export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    content: {
      type: Object,
      default: () => { return {} }
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      dataForm: this.content || {},
      types: [
        { label: '课程', value: 1 },
        { label: '题库', value: 2 },
        { label: '阅读资料', value: 3 },
        { label: '实体资料', value: 4 },
        { label: '信息资讯', value: 5 },
        { label: '学长学姐', value: 6 }
      ],
      sites: [
        { label: '院校页', value: 1 },
        { label: '专业页', value: 2 },
      ],
      layouts: [
        { label: '横向', value: 'row' },
        { label: '纵向', value: 'column' }
      ],
      groups: [],
      rules: {
        title: [{ required: true, message: '请输入版块标题', trigger: 'blur' }],
        site: [{ required: true, message: '请选择版块位置', trigger: 'change' }],
        type: [{ required: true, message: '请选择推荐类型', trigger: 'change' }],
        layout: [{ required: true, message: '请选择布局方向', trigger: 'change' }]
      }
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    content(val) {
      this.dataForm = val
      if (val.type) {
        if ([1].includes(val.type)) {
          this.fetchProductCategoryList()
        } else if ([3].includes(val.type)) {
          this.fetchReadCategoryList()
        } else if ([4].includes(val.type)) {
          this.fetchMaterialCategoryList()
        } else if ([5].includes(val.type)) {
          this.fetchArticleCategoryList()
        } else {
          this.groups = []
        }
      }
    },
    'dataForm.group_id': {
      handler(value) {
        console.log(value, 'value');
        if (value !== "") {
          const params = this.dataForm.params ? JSON.parse(this.dataForm.params) : {}
          params.category_id = value
          if (this.groups.length) {
            params.category_name = this.groups.find((v) => { return v.id == value }).name
          }
          this.dataForm.params = JSON.stringify(params)
        } else {
          /*       const params = this.dataForm.params ? JSON.parse(this.dataForm.params) : {}
                console.log(params);
                delete params.category_id */
          this.dataForm.params = JSON.stringify({})
        }
      }
    },
  },
  methods: {
    // 产品分类查询
    fetchProductCategoryList() {
      productCategoryList({ isPaging: 0 }).then(res => {
        if (res) {
          this.groups = res.list
        }
      })
    },
    // 文章分类查询
    fetchArticleCategoryList() {
      articleCategoryList({ isPaging: 0 }).then(res => {
        if (res) {
          this.groups = res.list
        }
      })
    },
    // 阅读资料分类查询
    fetchReadCategoryList() {
      readcategorylist({ isPaging: 0 }).then(res => {
        if (res) {
          this.groups = res.list
        }
      })
    },
    // 实体资料分类查询
    fetchMaterialCategoryList() {
      materialcategorylist({ isPaging: 0 }).then(res => {
        if (res) {
          this.groups = res.list
        }
      })
    },
    handleTypChange(val) {
      this.dataForm.group_id = ""
      this.dataForm.params = JSON.stringify({})
      if ([1].includes(val)) {
        this.fetchProductCategoryList()
      } else if ([3].includes(val)) {
        this.fetchReadCategoryList()
      } else if ([4].includes(val)) {
        this.fetchMaterialCategoryList()
      } else if ([5].includes(val)) {
        this.fetchArticleCategoryList()
      } else {
        this.groups = []
      }
    },
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const params = {
            id: this.dataForm.id,
            title: this.dataForm.title,
            subtitle: this.dataForm.subtitle,
            type: this.dataForm.type,
            group_id: this.dataForm.group_id || null,
            params: this.dataForm.params || null,
            max_num: this.dataForm.max_num || 3,
            site: this.dataForm.site,
            layout: this.dataForm.layout,
            // link_url: this.dataForm.link_url,
            sort: this.dataForm.sort,
            status: this.dataForm.status ? 1 : 0
          }
          collegeSectionUpdate(params).then(res => {
            this.$message.success(`更新成功`)
            this.$refs['dataForm'].resetFields()

            this.$emit('submit')
            this.handleClose()
          }).catch(error => {
            console.log('error: ', error)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose() {
      this.$emit('close')
    },
  }
}
</script>

<style lang="less" scoped>
.dialog-wrap {
  .form {
    margin-bottom: -18px;
  }
}
</style>
